$(function(){
    const pauseAudios = () => {
        $("audio").on("play", function() {
            $("audio").not(this).each(function(index, audio) {
                audio.pause();
                $(audio).closest('.custom-audio-element').find('.js-play-audio')
                    .removeClass('btn-sound-pause')
                    .removeClass('btn-large-sound-pause')
                    .removeClass('btn-medium-sound-pause')
                    .removeClass('btn-profile-sound-pause');
            });
        });
    }

    pauseAudios()

    window.__pauseOtherAudios = pauseAudios
});
